import { getYear } from "../../utils/datetime_utils"
import { TextEditor } from "../TextEditor"

export const ProjectSection = ({  project, onChange }) => {
    const handleFieldChange = (field, value) => {
        if (onChange) {
            onChange(project.id, field, value);
        }
    };

    return (
        <div key={project.id} className="py-4">
            <input 
                className="w-full px-2 py-2 border-b border-gray-200 mb-3 font-semibold text-gray-900 bg-transparent focus:outline-none focus:border-indigo-300" 
                value={project.title} 
                onChange={(e) => handleFieldChange('title', e.target.value)}
            />
            <div className="grid grid-cols-1 md:grid-cols-4 gap-3 md:items-end">
                {/* Organization */}
                <input
                    className="md:col-span-2 w-full px-2 py-2 border-b border-gray-200 font-semibold text-gray-800 bg-transparent focus:outline-none focus:border-indigo-300"
                    value={project.organization}
                    onChange={(e) => handleFieldChange('organization', e.target.value)}
                />

                {/* Dates aligned to right */}
                <div className="md:col-span-2 flex items-center gap-2 justify-self-end">
                    <input
                        className="w-16 text-right px-2 py-2 border-b font-semibold border-gray-200 text-gray-600 bg-transparent focus:outline-none focus:border-indigo-300"
                        value={getYear(project.start_date)}
                        onChange={(e) => handleFieldChange('start_date', e.target.value)}
                    />
                    <span className="text-gray-500 font-bold">-</span>
                    <input
                        className="w-16 text-right px-2 py-2 border-b font-semibold border-gray-200 text-gray-600 bg-transparent focus:outline-none focus:border-indigo-300"
                        value={getYear(project.end_date)}
                        onChange={(e) => handleFieldChange('end_date', e.target.value)}
                    />
                </div>
            </div>

            <div className="mt-3">
                <TextEditor 
                    initial={project.description} 
                    onChange={(value) => handleFieldChange('description', value)}
                />
            </div>
        </div>
    )
}